import React from 'react';
import * as S from './styles';

type OwnProps = {
  storeInfo?: (string | null)[] | null;
};

export const StoreInfoList = React.memo(
  ({ storeInfo }: OwnProps) =>
    storeInfo && storeInfo.length && storeInfo.filter(item => item).length ? (
      <S.StoreInfoList>
        {storeInfo.map((value, index) => (
          <S.StoreInfoText
            // eslint-disable-next-line react/no-array-index-key
            key={`store-info-${index}`}
          >
            <S.StoreInfoTextInner>{value}</S.StoreInfoTextInner>
          </S.StoreInfoText>
        ))}
      </S.StoreInfoList>
    ) : null,
  ({ storeInfo: prevStoreInfo }, { storeInfo: nextStoreInfo }) => {
    if (!prevStoreInfo && !nextStoreInfo) {
      return true;
    }

    if (
      (!prevStoreInfo && nextStoreInfo) ||
      (prevStoreInfo && !nextStoreInfo) ||
      prevStoreInfo?.length !== nextStoreInfo?.length
    ) {
      return false;
    }

    if (prevStoreInfo && nextStoreInfo) {
      return prevStoreInfo.every((value, i) => value === nextStoreInfo[i]);
    }

    return false;
  }
);
